<template>
  <div class="waitHouse">
    <div class="top_wrap">
      <div class="key_top">
        <ul class="key_list">
          <li class="conditions_list_item">
            <el-input v-model="search.keyword" placeholder="房源编号" @input="selectSearch(true)" clearable></el-input>
          </li>
          <li class="conditions_list_item">
            <span style="min-width:60px;">房源类型：</span>
            <el-select v-model="search.housingProperty" placeholder="不限" @change="selectSearch(true)" clearable>
              <el-option v-for="(item,index) in HousingList" :key="index" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="conditions_list_item many_item">
            <span style="min-width:60px;">建筑类型：</span>
            <el-select v-model="search.houseResourceType" multiple collapse-tags placeholder="不限" @change="selectSearch(true)" clearable>
              <el-option v-for="(item,index) in houseTypeList" :key="index" :label="item.valueDesc" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <li class="conditions_list_item">
            <span style="min-width:48px;">录入人：</span>
            <el-select v-model="search.submitter" placeholder="请输入" @change="selectSearch(true)" filterable clearable>
              <el-option v-for="(item,index) in employeeIdList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </li>
          <li class="conditions_list_item">
            <span style="min-width:60px;">审批状态：</span>
            <el-select v-model="search.approvalStatus" placeholder="不限" @change="selectSearch(true)" clearable>
              <el-option v-for="(item,index) in ApprovalList" :key="index" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </li>
        </ul>
        <!-- end -->
      </div>
      <div class="key_top">
        <ul class="key_list">
          <li class="conditions_list_item">
            <div class="Residential">
              <el-autocomplete popper-class="my-autocomplete" v-model="ResidentialName" :fetch-suggestions="querySearchAsync" placeholder="请输入小区" @clear="search.tungId='',search.unitId='',selectSearch(true)" @select="ResidentialNameChange" clearable>
                <template slot-scope="{ item }">
                  <div class="name" @select="handleSelect">{{ item.name }}</div>
                </template>
              </el-autocomplete>
            </div>
          </li>
          <li class="conditions_list_item">
            <el-select v-model="search.prefix" placeholder="编号前缀" @change="getHouselist(houseInfo,'change')" clearable>
              <el-option v-for="(item) in simplePrefix" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </li>
          <li class="conditions_list_item">
            <el-select v-model="search.tungId" placeholder="栋座" @visible-change="getSimpleTung" @change="selectSearch(true),search.unitId=''" clearable>
              <el-option v-for="(item,index) in simpleTungList" :key="index" :label="item.tungNumber" :value="item.tungId"></el-option>
            </el-select>
          </li>
          <li class="conditions_list_item">

            <el-select v-model="search.unitId" placeholder="单元" @visible-change="getSimpleUnit" @change="selectSearch(true)" clearable>
              <el-option v-for="(item,index) in simpleUnitList" :key="index" :label="item.unitNumber" :value="item.unitId"></el-option>
            </el-select>
          </li>
          <li class="conditions_list_item">
            <span>录入时间：</span>
            <div class="idcode">
              <el-date-picker v-model="search.date" unlink-panels value-format="yyyy-MM-dd" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change="selectSearch(true)"></el-date-picker>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="key_list_wrap sales_list_wrap">
      <el-table :data="KeyList" border style="width: 100%" :header-cell-style="setHeaderStyle" @row-dblclick="operation" @row-click="rowColorclick" highlight-current-row>
        <el-table-column prop="buildingInfoId" label="编号">
          <template slot-scope="scope">
            <el-button :class="{rowColor:scope.row.buildingInfoId===isRowColor}" type="text" size="medium" style="text-decoration:underline" @click="HousingDetails(scope.row.buildingInfoId,scope.row.housingProperty,scope.row.employeeId)">
              {{scope.row.houseCode}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型"></el-table-column>
        <el-table-column prop="buildingType" label="建筑类型"></el-table-column>
        <el-table-column prop="houseAddress" label="房源地址"></el-table-column>
        <el-table-column prop="area" label="面积（㎡）"></el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column prop="property" label="性质"></el-table-column>
        <el-table-column prop="houseCategory" label="房源类别"></el-table-column>
        <el-table-column prop="approvalStatus" label="审批状态">
          <template slot-scope="scope">
            <span style="color:#ff42a0;" v-if="scope.row.approvalStatus=='待提交'">{{scope.row.approvalStatus}}</span>
            <span style="color:#ffa500;" v-if="scope.row.approvalStatus=='审批中'">{{scope.row.approvalStatus}}</span>
            <span style="color:#ff0000;" v-if="scope.row.approvalStatus=='审批拒绝'">{{scope.row.approvalStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="submitter" label="录入人"></el-table-column>
        <el-table-column prop="submissionTime" label="录入时间" width="200px;"></el-table-column>
      </el-table>
      <div class="footer_pages">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { queryKey, communitynameQuery, employeeQuery } from "@/api/manageCenter";
import { houseQuery, simpleTung, simpleUnit, queryApprovalHouseList } from "@/api/houseManage";
import { dicGet } from "@/api";
import { housesSimplePrefix } from "@/mixins/housesSimplePrefix";
export default {
  name: "/waitHouse",
  mixins: [housesSimplePrefix],
  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "本季度",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      KeyList: [],
      housingData: [], //小区列表
      simpleTungList: [],//栋座列表
      simpleUnitList: [],//单元列表
      level: "",
      isRowColor: "",
      permisList,
      total: 0,
      currentPage: 1,
      pageNumber: 1, //从第几条开始
      pageSize: 20, //显示条数
      ResidentialName: "", //选择的小区名字
      buildingInfoId: "", //房源编号
      residentialAreaName: "", //小区名字
      keyId: "", //钥匙编号
      description: "", //备注
      HousingList: [], //房源状态列表
      houseTypeList: [],//建筑类型列表
      employeeIdList: [], //提交人
      ApprovalList: [], //审批状态
      //搜索
      search: {
        keyword: "", //房源编号
        housingProperty: "", //房源类型
        houseResourceType: [], //建筑类型
        submitter: "", //提交人
        approvalStatus: "", //审批状态
        residentialAreaId: "",//小区编号
        prefix: "",// 编号前缀
        tungId: "",//栋座
        unitId: "",//单元
        date: [],//收钥匙时间
      }
    };
  },
  mounted() {
    this.getlevel();//查询权限
    this.selectSearch(); //查询待审批房源列表
    this.getHousingCondition(); //房源状态
    this.gethouseTypeList(); //建筑类型
    this.getEmployeeIdList();//提交人列表
    this.getApprovalList();//审批状态列表
  },
  activated() {
    this.getlevel();//查询权限
    this.selectSearch(); //查询待审批房源列表
    this.getHousingCondition(); //房源状态
    this.gethouseTypeList(); //建筑类型
    this.getEmployeeIdList();//提交人列表
    this.getApprovalList();//审批状态列表
  },
  methods: {
    //查询列表
    selectSearch(val) {
      this.isRowColor = "";
      if (val) {
        this.pageNumber = 1;
        this.currentPage = 1;
      }
      let params = Object.assign({}, this.search)
      params["page.pageNumber"] = this.pageNumber * this.pageSize - this.pageSize;
      params["page.pageSize"] = this.pageSize;
      params.permissionLevel = this.level
      this.$post(queryApprovalHouseList, params).then(res => {
        if (res.success) {
          this.KeyList = res.data;
          this.total = res.total;
          this.KeyList.map(item => {
            if (item.submissionDate) {
              item.submissionDate = item.submissionDate.replace("T", "    ");
            }
          });
        }
      });
    },
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    //修改当前行字体颜色
    rowColorclick(row) {
      this.isRowColor = row.keyId;
    },
    querySearchAsync(queryString, cb) {
      // 查询小区
      let params = {
        name: queryString
      };
      this.$post(communitynameQuery, params).then(res => {
        if (res.success) {
          this.housingData = res.data;
          let restaurants = this.housingData;
          cb(restaurants);
          this.search.residentialAreaId = "";
          this.selectSearch(true);
        }
      });
    },
    handleSelect(item) {
      this.pageNumber = 1;
      this.pageSize = 20;
      this.currentPage = 1;
      this.search.residentialAreaId = item.residentialAreaId;
      this.ResidentialName = item.name;
      this.selectSearch(true);
    },
    //获取栋座
    getSimpleTung(val) {
      if (val) {
        let params = {
          residentialAreaId: this.search.residentialAreaId,
          prefix: this.search.prefix,
        }
        this.$post(simpleTung, params).then(res => {
          this.simpleTungList = res.data;
        })
      }
    },
    //获取单元
    getSimpleUnit(val) {
      if (val) {
        let params = {
          tungId: this.search.tungId
        }
        this.$post(simpleUnit, params).then(res => {
          this.simpleUnitList = res.data;
        })
      }
    },
    //查询权限
    getlevel() {
      let menu = JSON.parse(localStorage.getItem("menu"));
      if (menu) {
        menu.map(item => {
          if (item.name == "房源管理") {
            item.childMenus.map(child => {
              if (child.name == "待审批房源") {
                child.functions.map(func => {
                  if (func.functionName == "待审批房源查看") {
                    this.level = func.level
                  }
                })
              }
            });
          }
        });
      }
    },
    //获取房源状态
    getHousingCondition() {
      this.HousingList = [
        { name: "出租", value: "LEASE" },
        { name: "出售", value: "SELL" }
      ];
    },
    // 查询建筑类型
    gethouseTypeList() {
      let params = {
        code: "areaArchitecturalType"
      };
      this.$post(dicGet, params).then(res => {
        if (res.success) {
          this.houseTypeList = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    // 获取签约人列表
    getEmployeeIdList() {
      let params = {
        name: "",
        status:'ENABLE',
      };
      this.$post(employeeQuery, params).then(res => {
        if (res.success) {
          this.employeeIdList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    // 获取签约人列表
    getApprovalList() {
      this.ApprovalList = [
        { name: "不限", value: "" },
        { name: "待提交", value: "WAITING_FOR_APPROVAL" },
        { name: "审批中", value: "TO_BE_AUDITED" },
        { name: "审批拒绝", value: "UNABLE" }
      ];
    },
    //跳转详情
    HousingDetails(id, type, employeeId) {
      if (type == "SECONDHAND") {
        sessionStorage.setItem("sellHousebuildId", id);
        this.$router.push({ path: "/buildDetail" });
      } else if (type == "RENTING") {
        sessionStorage.setItem("rentHousebuildId", id);
        this.$router.push({ path: "/rentingBuildDetail" });
      } else if (type == "SHOP_SALE") {
        sessionStorage.setItem("sellShopbuildId", id);
        this.$router.push({ path: "/sellShopDetails" });
      } else if (type == "SHOP_RENTAL") {
        sessionStorage.setItem("rentShopbuildId", id);
        this.$router.push({ path: "/rentShopDetails" });
      }
      sessionStorage.setItem("buildId", id);
    },
    //分页
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.selectSearch();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.selectSearch();
    },
    //操作
    operation(row) {
      if (row.housingProperty == "SECONDHAND") {
        sessionStorage.setItem("sellHousebuildId", row.buildingInfoId);
        this.$router.push({ path: "/buildDetail" });
      } else if (row.housingProperty == "RENTING") {
        sessionStorage.setItem("rentHousebuildId", row.buildingInfoId);
        this.$router.push({ path: "/rentingBuildDetail" });
      } else if (row.housingProperty == "SHOP_SALE") {
        sessionStorage.setItem("sellShopbuildId", row.buildingInfoId);
        this.$router.push({ path: "/sellShopDetails" });
      } else if (row.housingProperty == "SHOP_RENTAL") {
        sessionStorage.setItem("rentShopbuildId", row.buildingInfoId);
        this.$router.push({ path: "/rentShopDetails" });
      }
      sessionStorage.setItem("buildId", row.buildingInfoId);
    },
    //表单头部颜色
    setHeaderStyle() {
      return "background-color: #F2F4FF";
    },
  }
};
</script>
<style type="text/css" lang="less">
.waitHouse {
  height: 100%;

  .el-table .cell,
  .el-table th div,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    text-align: center;
  }
  .top_wrap {
    padding: 20px 30px;
    background: #fff;
    .key_top {
      display: flex;
      align-items: center;

      background: #fff;
      .add_btn {
        margin-left: 30px;
        width: 100px;
        height: 30px;
        margin-bottom: 10px;
        background: #5e75e6;
        color: white;
        outline: none;
        border: none;
      }
      .key_list {
        display: flex;
        flex-wrap: wrap;

        .conditions_list_item {
          margin-right: 10px;
          display: flex;
          align-items: center;
          position: relative;
          cursor: pointer;
          > span {
            font-size: 12px;
          }
          .el-input {
            width: 120px;
            height: 30px;

            .el-input-group__append,
            .el-input-group__prepend {
              padding: 0 10px;
              background: #cccccc;
              border: none;
            }

            .el-input__inner {
              border: none;
              height: 30px;
              border: 1px solid #dbdbdb;
            }
            .el-input__icon {
              line-height: 30px;
            }

            .icon-icon_sousuo {
              color: white;
            }
          }

          .el-select {
            .el-input {
              width: 120px;
              .el-input__inner {
                width: 120px;
                height: 30px;
                border: none;
                color: black;
                padding: 0 10px;
                border: 1px solid #dbdbdb;
              }
              .el-input__icon {
                line-height: 30px;
              }
            }
          }
          .Residential {
            .el-input__inner {
              width: 120px;
              height: 30px;
              // border: none;
              // background: #f5f5f5;
            }
            .el-input__icon {
              line-height: 30px;
            }
          }
          .idcode {
            position: relative;
            .el-input {
              // margin-left: 10px;
              .el-input__inner {
                width: 100px;
                height: 30px;
                // border: none;
                // background: #f5f5f5;
                // padding: 0;
              }
              .el-input__icon {
                line-height: 30px;
              }
            }
            .el-range-editor.el-input__inner {
              height: 30px;
              line-height: 30px;
              .el-range-separator {
                height: 30px;
                line-height: 30px;
              }
              .el-input__icon {
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
        .many_item {
          .el-select {
            .el-input {
              width: 180px;
              .el-input__inner {
                width: 180px;
                height: 30px;
                border: none;
                color: black;
                padding: 0 10px;
                border: 1px solid #dbdbdb;
              }
              .el-input__icon {
                line-height: 30px;
              }
            }
          }
        }
      }

      //弹出框样式
      .el-dialog {
        width: 500px;

        .el-dialog__title {
          color: #5e75e6;
          font-size: 20px;
        }

        .el-dialog__close {
          font-size: 26px;
        }

        .el-dialog__body {
          padding-left: 0;
          padding-right: 0;
          padding-bottom: 0;
        }
      }
    }
    .key_top:first-child {
      .conditions_list_item {
        margin-bottom: 10px;
      }
    }
  }

  .key_list_wrap {
    height: 90%;

    .el-dialog {
      width: 600px;

      .el-dialog__title {
        color: #5e75e6;
        font-size: 20px;
      }

      .el-dialog__close {
        font-size: 26px;
      }

      .el-dialog__body {
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
      }
    }

    .footer_pages {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #5e75e6;
      }

      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        border: 1px solid #ccc;
        background: white;
      }
    }
  }
}
</style>
